import * as React from "react";
import { Container } from "react-bootstrap";
import Seo from "../components/Seo";

import { visionPageTplData } from "../data/page-tpl-vision.data";
import { getCurrentPageSeo } from "../helpers/richContentHelpers";

import Layout from "../components/Layout";
import PageFooterSections from "../components/PageFooterSections";

import PageHead from "../components/Page/PageHead";
import LifeAtAlgotrader from "../components/LifeAtAlgotrader";
import OurHistory from "../components/OurHistory";

import ImageSection from "../components/ImageSection";
import Section from "../components/Section";

import Hero from "../componentsSections/Hero";

const pageVision = ({ pageContext: { id } }) => {
    const seoPageData = getCurrentPageSeo(id);
    const pageData = visionPageTplData(id);

    return (
        <Layout pageTitle={seoPageData.title}>
            {/* SEO Metas */}
            <Seo post={seoPageData} />
            {/* HERO */}
            <Hero
                {...pageData.hero}
                textSize="big"
                className="-vision -full-width-copy"
            />

            <div className="vision-page">
                {/* Page head */}
                <Container>
                    <PageHead
                        title={pageData.pageHeader.header}
                        text={pageData.pageHeader.text}
                    />
                </Container>
                {/* Section Intitutional Trading */}
                <Section className="-small-margin-bottom"></Section>
                <ImageSection
                    containerClassName="-empower-section pt-2"
                    contentClassName="pt-3"
                    imageSection={pageData.institutionalTrading.imageSection}
                />
                {/* Section ImageSectionsGroup  */}

                <ImageSection
                    imageSection={pageData.imageSection}
                    flipped={true}
                />

                {/* Section Life At Algotrader  */}
                <LifeAtAlgotrader {...pageData.lifeAtAlgotrader} />
                {/* Section Our History */}
                <OurHistory
                    containerClassName="pt-lg-0"
                    {...pageData.ourHistory}
                />
            </div>

            <PageFooterSections pageData={pageData} />
        </Layout>
    );
};

export default pageVision;
